import { FC } from 'react';
import DetailPage, { DetailPageProps } from './detailPage';
import DetailPageAdd, { DetailPageAddProps } from './add';
import DetailPageEdit, { DetailPageEditProps } from './edit';
import DetailPageCustom, { DetailPageCustomProps } from './custom';
import Strategy from './strategy';
import { StrategyPageProps } from './interface';
import './style.less';

export type IDetailPageComponent = FC<DetailPageProps> & {
  /** 普通 */
  Add: FC<DetailPageAddProps>;
  Edit: FC<DetailPageEditProps>;
  /** 策略 */
  Strategy: FC<StrategyPageProps>;
  /** 自定义 */
  Custom: FC<DetailPageCustomProps>;
};

/** 详情页 */
const TransDetailPage = DetailPage as IDetailPageComponent;
TransDetailPage.Add = DetailPageAdd;
TransDetailPage.Edit = DetailPageEdit;
TransDetailPage.Strategy = Strategy;
TransDetailPage.Custom = DetailPageCustom;

export default TransDetailPage;
